
export enum GuardFeatures {
    // #region Non-Fabric workspace only, e.g. ADF, A365, Fabric Mount DF
    ADFRerunTWTriggerRange = 'ADFRerunTWTriggerRange',
    ADFChainingTriggerFeature = 'ADFChainingTriggerFeature',
    ADFVNet = 'ADFVNet',
    ADFSynapseVNet = 'ADFSynapseVNet',
    ADFDataFlowExternalComputeInfo = 'ADFDataFlowExternalComputeInfo',
    ADFDataflowEnableHive = 'ADFDataflowEnableHive',
    ADFDataMapperSaveFeature = 'ADFDataMapperSaveFeature',
    ADFCDC = 'ADFCDC',
    ADFCDCInitialLoad = 'ADFCdcInitialLoad',
    ADFDataFlowSchemaTimeoutForUX = 'ADFDataFlowSchemaTimeoutForUX',
    ADFDataFlowConnectionTimeoutForUX = 'ADFDataFlowConnectionTimeoutForUX',
    ADFOptionalPasswordToWebActivity = 'ADFOptionalPasswordToWebActivity',
    RerunRangeMaxAllowedFeatureName = 'ADFMaxRerunTriggersCount',
    ADFMaxTumblingWindowDependencyCount = 'ADFMaxTumblingWindowDependencyCount',
    ExpressionValidation = 'ADFExpressionValidation',
    ADFTumblingWindowTriggerValidateDependencySize = 'ADFTumblingWindowTriggerValidateDependencySize',
    UX_SupportSapTableRowSkips = 'UX_SupportSapTableRowSkips',
    UX_SsisIREnableVNetV2Feature = 'UX_SsisIREnableVNetV2Feature',
    ADFDataflowGoogleCloudStorageSource = 'ADFDataflowGoogleCloudStorageSource',
    ADFDataflowM365 = 'ADFDataflowM365',
    ADFUseSparkGatewayInAdf = 'ADFUseSparkGatewayInAdf',
    ADFSparkGatewayManagedVnet = 'ADFSparkGatewayManagedVnet',
    ADFSparkGatewayMultiRegion = 'ADFSparkGatewayMultiRegionSupport',
    ADFSparkGatewayQuickReuse = 'ADFSparkGatewayQuickReuse',
    UX_EnableHdfsHttpfs = 'UX_EnableHdfsHttpfs',
    UX_EnableSsisIRSharing = 'UX_EnableSsisIRSharing',
    UX_SupportSharePointOnlineFile = 'UX_SupportSharePointOnlineFile',
    ADFDataflowSwitchWarmpoolToReuse = 'ADFDataflowSwitchWarmpoolToReuse',
    UX_SupportSapCdcConnector = 'UX_SupportSapCdcConnector',
    UX_EnableFabricCapacityCreation = 'UX_EnableFabricCapacityCreation',
    ADMSTrino = 'UX_EnableTrino',
    ADFDataflowOnPremOracle = 'ADFDataflowOnPremOracle',
    ADFIntegrationRuntimeAirflow = 'ADFIntegrationRuntimeAirflow',
    ADFAirflowAutoscaleEnabled = 'ADFAirflowAutoscaleEnabled',
    ADFAirflowAutoscaleUpdateEnabled = 'ADFAirflowAutoscaleUpdateEnabled',
    ADFEnableClearStorageForAirflowImport = 'ADFEnableClearStorageForAirflowImport',
    ADFDataFlowEnableCustomConfigurationFromIR = 'ADFDataFlowEnableCustomConfigurationFromIR',
    ADFDataflowRemoveComputeTypeFromIR = 'ADFDataflowRemoveComputeTypeFromIR',
    ADFDataflowCustomProperties = 'ADFDataflowCustomProperties',
    ADFEnableEmailActivityInUI = 'ADFEnableEmailActivityInUI',
    ADFDataflowSapOData = 'ADFDataflowSapOData',
    UX_SsisIRSupportEvergreen = 'UX_SsisIRSupportEvergreen',
    UX_EnableADFLakehouseSchema = 'UX_EnableADFLakehouseSchema',
    ADFEnablePowerQueryActivityInADF = 'ADFWranglingDataflowFeature',
    UX_EnableWebhookOnIR = 'UX_WebhookOnIR',
    ADFSupportTeradataSinkForNonFabricEnvUX = 'ADFSupportTeradataSinkForNonFabricEnvUX',
    SupportExploratoryAPIForOAP = 'SupportExploratoryAPIForOAP',
    SupportTeradataSinkForNonFabricEnv = 'SupportTeradataSinkForNonFabricEnv',
    UX_EnableSelectInServiceNowV2 = 'UX_EnableSelectInServiceNowV2',
    // #endregion
    // #region Fabric workspace only
    ADFEnableDatabricksActivityInTrident = 'ADFDatabricksActivtyInTrident',
    ADFEnableAzureDatabricksJobActivityInTrident = 'ADFAzureDatabricksJobActivityInTrident',
    ADFAzureDatabricksJobActivity = 'ADFAzureDatabricksJobActivity',
    ADFEnableHDInsightActivityInTrident = 'ADFHDInsightActivityInTrident',
    ADFTriggerVariablesInTridentUI = 'ADFTriggerVariablesInTridentUI',
    EnableDFG21Param = 'EnableDFG21Param',
    UseTokenServiceInDFActivity = 'UseTokenServiceInDFActivity',
    UseTokenServiceInDataflowActivity = 'UseTokenServiceInDataflowActivity',
    ADFEnableWIForWebBasedActivities = 'ADFEnableWIForWebBasedActivities',
    ADFEnableWIForCustomMLActivities = 'ADFEnableWIForCustomMLActivities',
    ADFEnableWIForDFActivity = 'ADFEnableWIForDFActivity',
    UX_EnableFabricSql = 'UX_EnableFabricSql',
    ADFEnableCopyJobActivityInTrident = 'ADFEnableCopyJobActivityInTrident',
    DbtJobLakehouseAdapter = 'DbtJobLakehouseAdapter',
    DbtJobFabricSqlAdapter = 'DbtJobFabricSqlAdapter',
    EnableApiIntegrationActivity = 'EnableApiIntegrationActivity',
    UX_EnableFabricActionPicker = 'UX_EnableFabricActionPicker',
    // #endregion
    // #region Shared between Fabric and non-Fabric
    ADFEnableScopeActivity = 'ADFEnableScopeActivity',
    ADFScopeActivtyRestriction = 'ADFScopeActivtyRestriction',
    ADFEnableADLSCosmosDataset = 'ADFEnableADLSCosmosDataset',
    ADFSupportLargeNumberOfActivities = 'ADFSupportLargeNumberOfActivities',
    ADFMaxActivityCountWithLargeNumberOfActivities = 'ADFDefaultMaxActivityCountWithLargeNumberOfActivities',
    // #endregion
}

export enum ExposureControlType {
    AllowList = 'AllowList',
    Feature = 'Feature',
    Dictionary = 'Dictionary'
}

export type FeatureScope = 'ADMS' | undefined;

export interface IFeatureValue {
    featureName: string;
    featureType?: ExposureControlType;
    featureScope?: FeatureScope;
    value?: string;
}

export interface IFeatureValueResponse {
    [feature: string]: string | boolean;
}
